import React from "react";

export const Header = ({ onLogout, user }) => {
  return (
    <header className="bg-gradient-to-r from-[#1a074f] to-[#270b79] shadow-2xl border-b-4 border-[#F06B32] relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#F06B32] rounded-full opacity-10 blur-xl"></div>
        <div className="absolute -bottom-20 -left-20 w-40 h-40 bg-blue-500 rounded-full opacity-10 blur-xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-purple-500 rounded-full opacity-5 blur-lg"></div>
      </div>

      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex items-center justify-between relative z-10">
        
        {/* Logo/Brand Section */}
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-gradient-to-br from-[#F06B32] to-orange-400 rounded-xl flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <div className="hidden sm:block">
            <h2 className="text-lg font-semibold text-white">Stackerbee AI</h2>
            <p className="text-xs text-gray-300">Powered by AI</p>
          </div>
        </div>

        {/* Center Title Section */}
        <div className="flex-1 mx-8 text-center">
          <div className="flex flex-col items-center">
            <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">
              AI Creative Studio
            </h1>
            <p className="mt-1 text-sm text-gray-300 max-w-2xl">
              Transform your images into stunning visual content instantly
            </p>
          </div>
        </div>

        {/* Right Section - User Info & Logout */}
        <div className="flex items-center space-x-4">
          {/* User Info */}
          {user && (
            <div className="hidden md:flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2 border border-white/20">
              <div className="w-8 h-8 bg-gradient-to-br from-[#F06B32] to-orange-400 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-semibold">
                  {user.username?.charAt(0).toUpperCase() || 'U'}
                </span>
              </div>
              <div className="text-right">
                <p className="text-sm font-medium text-white">
                  {user.username || 'User'}
                </p>
                <p className="text-xs text-gray-300">Welcome back!</p>
              </div>
            </div>
          )}

          {/* Logout Button */}
          <button
            onClick={onLogout}
            className="group bg-gradient-to-r from-[#F06B32] to-orange-500 hover:from-[#d85e29] hover:to-orange-400 text-white font-semibold px-6 py-3 rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#F06B32] focus:ring-offset-2 focus:ring-offset-[#1a074f] flex items-center space-x-2"
          >
            <svg className="w-4 h-4 group-hover:rotate-90 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Progress/Status Bar (optional) */}
      <div className="h-1 bg-gradient-to-r from-[#F06B32] via-orange-400 to-[#F06B32] animate-pulse opacity-80"></div>
    </header>
  );
};